import type { AllRouteEndpoints } from "../routeTypes";
export const bannersDismissCacheKeys: AllRouteEndpoints[] = [];
